import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=49f156be&"
import script from "./Costs.vue?vue&type=script&lang=ts&"
export * from "./Costs.vue?vue&type=script&lang=ts&"
import style0 from "./Costs.vue?vue&type=style&index=0&id=49f156be&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('/opt/atlassian/pipelines/agent/build/components/guidance/Guidance.vue').default,Modal: require('/opt/atlassian/pipelines/agent/build/components/Modal.vue').default})
